module.exports = __webpack_public_path__ + "static/media/media.c66382cc.png";